const body = document.body;
let ver = '';
const iOSversion = function () {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    let v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }
};
// Runs check for ios version and only applies class if it's IOS
const init = () => {
  if (iOSversion()) {
    ver = iOSversion();
    ver = parseInt(ver);
    body.classList.add('ios' + ver);
  }
};
export { init };
